import { useEffect, useState } from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';

type LoadingProgressProps = {
  noResult: boolean;
  setLoading: (newLoading: boolean) => void;
}

const LOADING_STEPS = [
  "Analyzing Values",
  "Analyzing Strengths",
  "Identifying Key Themes",
  "Generating Personalized List of Purposes",
  "Identifying Best Fit",
  "Determining Final Pairing",
  "Generating Additional Descriptors",
  "Identifying Best Final Options",
  "Choosing Final Life Purpose Statements",
  "Providing Explanations",
]
// multiply delay by 100 to get the number of milliseconds per LOADING_STEP
const SLOW_DELAY = 120
const FAST_DELAY = 5

export default function LoadingProgress({ noResult, setLoading }: LoadingProgressProps) {
  const [stepIndex, setStepIndex] = useState(0)
  const [now, setNow] = useState(1)
  const currentStep = LOADING_STEPS[stepIndex]

  useEffect(() => {
    const delay = noResult ? SLOW_DELAY : FAST_DELAY
    if (now < 1000) {
      setTimeout(increment.bind(null, now, stepIndex), delay)
    }
  }, [now])

  useEffect(() => {
    if (now >= 1000 && !noResult) {
      setLoading(false)
    }
  }, [now, noResult])

  function increment(prevNow: number, prevIndex: number) {
    const newNow = prevNow + 1
    let newIndex = prevIndex
    if (newNow % 100 === 0 && newIndex < 9) {
      newIndex += 1
      setStepIndex(newIndex)
    }
    setNow(newNow)
  }
  
  const adjustedNow = noResult ? now % 100 : 100;

  return (
    <>
      <ProgressBar animated now={adjustedNow} />
      <h5>{currentStep}</h5>
    </>
  )
}
